import React from "react";
import { Navigate } from "react-router-dom";
import { useCanAccess } from "../rbac/useCanAccess";
import { useHomeRoute } from "../rbac/useHomeRoute";
import DashboardPage from "./DashboardPage";

/**
 * Smart home page that renders the one-page dashboard if the user has access to '/',
 * otherwise redirects to the first accessible route based on RBAC permissions.
 *
 * This allows roles like "Operational" (which only have access to operational routes)
 * to be redirected to their appropriate home page instead of seeing a blank/403 page.
 */
const SmartHomePage: React.FC = () => {
    const { canAccess, isLoading } = useCanAccess();
    const getHomeRoute = useHomeRoute();

    // Wait for RBAC to finish loading before making redirect decisions
    if (isLoading) {
        return null;
    }

    // If user has access to '/', show the default dashboard
    if (canAccess("/")) {
        return <DashboardPage />;
    }

    // Otherwise redirect to the first accessible route
    const homeRoute = getHomeRoute();
    return <Navigate to={homeRoute} replace />;
};

export default SmartHomePage;
